import { render, staticRenderFns } from "./av-select.vue?vue&type=template&id=4a918af9"
import script from "./av-select.vue?vue&type=script&lang=js"
export * from "./av-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports